export default {
    inject: ['arrematanteContainer'],
    computed: {
        arrematante() {
            return this.arrematanteContainer.arrematante
        }
    }
}
